function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

/**
 * Base class for application errors, carries an error code unique for the error type.
 */
var AppError = function (_extendableBuiltin2) {
  _inherits(AppError, _extendableBuiltin2);

  function AppError(message, errorCode) {
    _classCallCheck(this, AppError);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    var _this = _possibleConstructorReturn(this, _extendableBuiltin2.call(this, message));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, AppError);
    }

    // Custom

    _this.errorCode = errorCode;
    return _this;
  }

  return AppError;
}(_extendableBuiltin(Error));

/**
 * Shallow equals function.
 */
var shallowEquals = function shallowEquals(a, b) {
  var i = void 0;

  if (!a || !b) {
    return a == b;
  }

  for (i in a) {
    if (!(i in b)) {
      return false;
    }
  }

  for (i in b) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
};

/**
 * Deep equals function.
 */
var deepEquals = function deepEquals(a, b) {
  var i = void 0;
  if (typeof a !== "object" && !Array.isArray(a) || typeof b !== "object" && !Array.isArray(b) || a === null || b === null) {
    return a == b;
  }

  for (i in a) {
    if (!(i in b)) {
      return false;
    }
  }
  for (i in b) {
    if (!deepEquals(a[i], b[i])) {
      return false;
    }
  }
  return true;
};

/**
 * Simple debounce-function which will delay execution of the wrapped function by `timeout`.
 *
 * NOTE: The arguments provided will be forwarded, but only the last call will be performed
 * once it times out.
 */
var debounce = function debounce(f) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

  var t = null;

  return function () {
    var args = arguments;
    var ctx = this;

    clearTimeout(t);

    t = setTimeout(function () {
      t = null;

      f.apply(ctx, args);
    }, timeout);
  };
};

/**
 * Simple throttle-function which will prevent additional calls from going through
 * until `timeout` milliseconds has passed. If `queue=true` and at least one call
 * happens during the timeout, the function will be called with the last supplied
 * parameters an additional time and then refresh the timeout.
 */
var throttle = function throttle(f) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  var queue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var t = null;
  var n_ctx = undefined;
  var n_args = undefined;

  return function fun() {
    if (t) {
      // We are already waiting for timeout, set context and args for next call
      n_ctx = this;
      n_args = arguments;

      return;
    }

    n_ctx = undefined;
    n_args = undefined;
    t = setTimeout(function () {
      t = null;

      if (queue && (n_ctx !== undefined || n_args !== undefined)) {
        fun.apply(n_ctx, n_args);
      }
    }, timeout);

    f.apply(this, arguments);
  };
};

/**
 * Polyfill of Array.prototype.find.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 */
var find = function find(array, _find) {
  for (var i = 0; i < array.length; i++) {
    if (_find(array[i], i, array)) {
      return array[i];
    }
  }

  return null;
};

var ESCAPE_REGEX = /[-\/\\^$*+?.()|[\]{}]/g;

/**
 * Escapes regular expression special characters in a string, making it suitable
 * for use in regular expressions as a literal.
 */
var escapeRegexp = function escapeRegexp(str) {
  return str.replace(ESCAPE_REGEX, "\\$&");
};

/**
 * Returns true if the supplied object is a promise.
 */
var isPromise = function isPromise(promise) {
  return promise && typeof promise === "object" && typeof promise.then === "function";
};

/**
 * Creates a delay step for a promise-chain, passing through any value in the
 * promise chain.
 */
var delay = function delay(time) {
  return function (t) {
    return new Promise(function (resolve, _) {
      return setTimeout(function () {
        return resolve(t);
      }, time);
    });
  };
};

/**
 * Indexing operator.
 */
var _idx = function _idx(o, i) {
  return typeof o === "object" && o ? o[i] : null;
};

/**
 * Indexes deeply into the supplied object using a dot-notation string and returns the value if any.
 */
var get = function get(o, k, def) {
  return k.split(".").reduce(_idx, o) || def;
};

var _set = function _set(o, k, v) {
  var _Object$assign;

  if (!k.length) {
    return v;
  }

  var i = k[0];
  var m = _idx(o, i, {});
  var n = _set(m, k.slice(1), v);

  return n !== m ? Object.assign({}, o, (_Object$assign = {}, _Object$assign[i] = n, _Object$assign)) : o;
};

/**
 * Indexes deeply into the supplied object using a dot-notation string and sets the value.
 * If undefineds or non-objects are encountered on the way they will be converted to objects.
 * The input variable `o` will not be modified, instead a new object is returned.
 */
var set = function set(o, k, v) {
  return _set(o, k.split("."), v);
};

/**
 * Creates a shallow copy of the object without the keys listed.
 */
var objectExclude = function objectExclude(o, keys) {
  var n = {};

  for (var p in o) {
    if (o.hasOwnProperty(p) && keys.indexOf(p) === -1) {
      n[p] = o[p];
    }
  }

  return n;
};

/**
 * Performs a deep merge of objects supplied, with the rightmost winning, skipping undefined
 * values.
 *
 * Arrays are preserved but merged by index.
 */
var objectDeepMerge = function objectDeepMerge() {
  for (var _len = arguments.length, objects = Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  return objects.reduce(function (a, o) {
    for (var p in o) {
      if (o.hasOwnProperty(p)) {
        if (typeof o[p] === "object" && o[p] && a[p]) {
          a[p] = objectDeepMerge(a[p], o[p]);
        } else if (typeof o[p] !== "undefined") {
          a[p] = o[p];
        }
      }
    }

    return a;
  }, objects[0] && Array.isArray(objects[0]) ? [] : {});
};

var INTERPOLATE_PATTERN = /%(%|\w+)/g;

/**
 * Interpolates a string, replaces named placeholders denoted by %. % can be escaped
 * by using it twice. Will replace duplicate keys in the string.
 *
 * Example:
 *
 * ```
 * interpolate("Test %percent%%", { percent: 100 }) # => "Test 100%"
 * interpolate("Test %missing", { percent: 100 }) # Warning: interpolate: Missing parameter 'missing' in 'Test %missing'.
 * interpolate("Test %missing", { percent: 100 }, 'custom.identifier') # Warning: interpolate: Missing parameter 'missing' in 'custom.identifier'.
 * ```
 */
var interpolate = function interpolate(str, binds, identifier) {
  return str.replace(INTERPOLATE_PATTERN, function (_, key) {
    // Special case for escaped %
    if (key === "%") {
      return "%";
    }

    if (binds && binds.hasOwnProperty(key)) {
      return binds[key];
    }

    if (process.env.NODE_ENV !== "production") {
      console.warn("interpolate: Missing parameter '" + key + "' in '" + (identifier || str) + "'.");
    }

    return "%" + key;
  });
};

export { AppError, shallowEquals, deepEquals, debounce, throttle, find, escapeRegexp, isPromise, delay, get, set, objectExclude, objectDeepMerge, interpolate };
//# sourceMappingURL=index.es2015.js.map
